module.exports = __webpack_public_path__ + "static/media/terapia_casal.2097f0d3.png";